import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { appRouter } from '@/router/router'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
        lang: 'ZH_CN',
        menuList: [],
        orgnizatioName: [],
        avatorPath: ''
	},
	mutations: {
		setMenuList(state){
            var menuList = []
            appRouter.forEach((item, index) => {
                menuList.push({
                    title: item.title,
                    icon: item.icon,
                    path: item.path,
                    name: item.name,
                    child: [],
                })
                var childrenArr = [];
                item.children.filter(child => {
                  childrenArr.push({
                    title: child.title,
                    path: child.path,
                    icon: child.icon,
                    name: child.name,
                  })
                })
                menuList[index].child = childrenArr
            })
            state.menuList = menuList
        },
    logout () {
        Cookies.remove('user')
        Cookies.remove('password')
        Cookies.remove('register')
        localStorage.removeItem('userid')
        localStorage.removeItem('nickname')
        localStorage.removeItem('tocken')
        localStorage.removeItem('phone')
        localStorage.removeItem('email')
        localStorage.removeItem('oid')
    },
    setAvator (state, path){
      state.avatorPath = path
    },
    setorgName (state, data) {
      state.orgnizatioName = [];
      for (var i = 0; i < data.length; i++) {
        state.orgnizatioName.push(data[i]);
      }
      localStorage.setItem('orgname',JSON.stringify(state.orgnizatioName))
    }
	},
	actions: {

	},
	modules: {

	}
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js